require("core-js/fn/map");
require("core-js/fn/set");
require("raf/polyfill");

module.exports = require("react/index.js");
